import filter from 'lodash/filter'
import React from 'react'
import { useProductMetadata } from './useProductMetadata'
import { MetadataDisplayContent } from './MetadataDisplayContent'

export const PublicMetadataDisplayContent = ({ value = [] }) => {
  const { publicMetadataSchema } = useProductMetadata()

  const publicValues = filter(value, (metadata) => {
    const schemaItem = publicMetadataSchema?.[metadata?.key]
    return !!schemaItem
  })

  return <MetadataDisplayContent value={publicValues} />
}
